import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Spinner = (): React.ReactElement => {
  return (
    <Box sx={{display: 'flex'}}>
      <CircularProgress />
    </Box>
  );
};

export default Spinner;
